import React from 'react';
import { cn } from '../index';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => (
  <span
    className={cn(
      'inline-block rounded-full border-[var(--border)] border-t-[var(--primary)] animate-spin',
      sizeMap[size],
      className,
    )}
    role="status"
    aria-label="Loading"
  />
);
